import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import ReactMenu from '../../../../components/common2/ReactMenu'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { integrationActions } from '../../actions'
import { openInNewTab } from 'srcReact/helpers/utils'
import SetTranslationKey from '../SetTranslationKey'
import Modal from 'srcReact/components/common2/Modal'
import ConfirmModal from 'srcReact/components/common2/ConfirmModal'

function IntegrationButton({
  imageType,
  integrationType,
  from,
  usage,
  orgId,
  isDefault = false,
  isActive = false,
  size = 'medium',
  isButton = true,
  email,
  authToken,
  connectAsDefault,
  openConfirmModal
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [imagePath, setImagePath] = useState('')
  const [buttonClicked, setButtonClicked] = useState(false)
  const [altText, setAltText] = useState('')
  const [isTranslationModalOpen, setIsTranslationModalOpen] = useState(false)

  const {
    common: { isNative },
    integration: {
      thirdPartyconnection: { loading: connectionLoading, API_connection, login_url }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (imageType) {
      switch (imageType) {
        case 'google_cal_small':
          setImagePath('/images/Google-calendarLogo.png')
          setAltText('Google calendar')
          break
        case 'google_cal_full':
          setImagePath('/images/google_calendar_full.png')
          setAltText('Google calendar')
          break
        case 'outlook_small':
          setImagePath('/images/Outlook-Logo.png')
          setAltText('Microsoft outlook')
          break
        case 'outlook_full':
          setImagePath('/images/outlook_full.png')
          setAltText('Microsoft outlook')
          break
        case 'google_meet_small':
          setImagePath('/images/Google-Meet-Logo.jpg')
          setAltText('google meet')
          break
        case 'google_meet_full':
          setImagePath('/images/google-meet.png')
          setAltText('google meet')
          break
        case 'ms_teams_small':
          setImagePath('/images/Microsoft_Office_Teams.png')
          setAltText('microsoft teams')
          break
        case 'ms_teams_full':
          setImagePath('/images/microsoft-teams.png')
          setAltText('microsoft teams')
          break
        case 'zoom':
          setImagePath('/images/zoom.png')
          setAltText('zoom')
          break
        case 'translate':
          setImagePath('/images/GoogleTranslateLogo.png')
          setAltText('Google translation')
          break
      }
    }
  }, [imageType])

  useEffect(() => {
    if (!connectionLoading && buttonClicked) {
      setButtonClicked(false)
      //NA for ical for now
      //ask for user's permission if not already logged in with google or microsoft outlook, else add event to respective calendar automatically
      if (!API_connection && login_url) {
        openInNewTab(login_url)
      }
    }
  }, [connectionLoading, API_connection, login_url, buttonClicked])

  const getOptions = () => {
    let options = []
    if (from === 'user_settings') {
      if (!isDefault) {
        options.push({
          text: t('global.makeDefault'),
          onClick: () => makeDefault()
        })
      }
      options.push({ text: t('global.delete'), onClick: () => deleteIntegration() })
    } else {
      if (isActive) {
        options.push({ text: t('integration.deactivate'), onClick: deactivateIntegration })
      } else {
        options.push({
          text: t('integration.activate'),
          onClick: usage === 'translate' ? openTranslationModal : activateIntegration
        })
      }
    }
    if (usage === 'translate' && isActive) {
      options.push({ text: t('Change key'), onClick: openTranslationModal })
    }
    return options
  }

  const makeDefault = () => {
    if (usage === 'virtual_meeting') {
      dispatch(integrationActions.setDefaultVirtualMeeting(integrationType, orgId, authToken))
    } else if (usage === 'add_to_calendar') {
      dispatch(integrationActions.setDefaultAddToCalendar(integrationType, orgId, authToken))
    }
  }
  const deleteIntegration = () => {
    if (openConfirmModal) {
      openConfirmModal({ type: integrationType, usage: usage, token: authToken, email: email, isDefault: isDefault })
    }
  }

  const openTranslationModal = () => {
    setIsTranslationModalOpen(true)
  }
  const closeTranslationModal = () => {
    setIsTranslationModalOpen(false)
  }

  const activateIntegration = () => {
    dispatch(integrationActions.updateIntegrations(orgId, integrationType, usage, 'activate'))
  }
  const deactivateIntegration = () => {
    dispatch(integrationActions.updateIntegrations(orgId, integrationType, usage, 'deactivate'))
  }

  const handleConnect = () => {
    if (usage === 'translation') {
      openTranslationModal()
    } else if (from === 'org_settings') {
      dispatch(integrationActions.updateIntegrations(orgId, integrationType, usage, 'activate'))
    } else {
      setButtonClicked(true)

      if (usage === 'add_to_calendar') {
        localStorage.setItem('addtocal', `0|${integrationType}`)
      }
      localStorage.setItem('default_integration', connectAsDefault)
      localStorage.setItem('integration_from', 'integration_settings')

      // To find usage for native app
      if (isNative) {
        localStorage.setItem('addtocal', `0|${integrationType}|${usage}`)
      }
      dispatch(integrationActions.getExternalAPIConnection(integrationType, orgId))
    }
  }
  return (
    <React.Fragment>
      {isButton ? (
        <button
          type='button'
          className={`${styles.btnContainer} ${styles[size]}`}
          aria-label={altText}
          onClick={handleConnect}>
          <img alt={altText} src={`${config.assetUrl}${imagePath}`} />
          {isDefault && <span className={styles.lblDefault}>{t('global.default')}</span>}
        </button>
      ) : (
        <div className={`${styles.btnContainer} ${from === 'user_settings' && styles.btnActive} ${styles[size]}`}>
          <img alt={altText} src={`${config.assetUrl}${imagePath}`} />
          <label className={styles.email}>{email}</label>
          {isDefault && <span className={styles.lblDefault}>{t('global.default')}</span>}
          {isActive && from === 'org_settings' && <span className={styles.lblDefault}>{t('global.active')}</span>}
          <ReactMenu
            direction='left'
            options={getOptions()}
            menuButtonCSS={styles.optionButton}
            menuCSS={styles.optinMenu}
            menuItemCSS={styles.optionMenuItem}
          />
        </div>
      )}
      {isTranslationModalOpen && (
        <Modal
          isOpen={isTranslationModalOpen}
          title={t('integration.setTranslationTitle')}
          handleClose={closeTranslationModal}>
          <SetTranslationKey orgId={orgId} closeModal={closeTranslationModal} />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default IntegrationButton
